// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"CollectionPageHeader_innerWrapper__79F_D"};